import React, { useId } from 'react';
import { StyledAccordion, StyledArrow, StyledHint, StyledIconContainer, StyledLabelContainer, StyledLabelSpan, StyledPanelInner, StyledSectionButton, StyledSectionHeading, StyledSectionPanel } from './index.styles.js';
import { Icon } from '../icon/index.js';
import { Badge } from '../badge/index.js';
import {} from '@oneaudi/unified-web-common';
const getSectionContent = ({ icon, label, hint, badge }) => {
    if (hint || badge) {
        return (React.createElement(StyledLabelContainer, null,
            icon ? (React.createElement(StyledIconContainer, null,
                React.createElement(Icon, { name: icon, size: "s" }),
                React.createElement(StyledLabelSpan, null, label))) : (label),
            hint && React.createElement(StyledHint, null, hint),
            badge && React.createElement(Badge, { ...badge })));
    }
    if (icon) {
        return (React.createElement(StyledIconContainer, null,
            React.createElement(Icon, { name: icon, size: "s" }),
            React.createElement(StyledLabelSpan, null, label)));
    }
    return label;
};
export const AccordionSection = ({ open, onToggle, children, label, hint, icon, badge, headingTag, disabled }) => {
    const id = useId();
    const sectionId = `${id}-section`;
    const controlId = `${id}-control`;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledSectionHeading, { as: headingTag, open: open },
            React.createElement(StyledSectionButton, { open: open, "aria-expanded": open, "aria-controls": sectionId, id: controlId, onClick: onToggle, disabled: disabled },
                getSectionContent({ icon, label, hint, badge }),
                React.createElement(StyledArrow, { name: "arrow-down", size: "s" }))),
        React.createElement(StyledSectionPanel, { role: "region", "aria-labelledby": controlId, id: sectionId, "aria-hidden": !open, open: open },
            React.createElement(StyledPanelInner, { open: open }, children))));
};
export const Accordion = ({ children, className, 'data-testid': dataTestId, margin }) => {
    return (React.createElement(StyledAccordion, { className: className, "data-testid": dataTestId, margin: margin }, children));
};
//# sourceMappingURL=index.js.map